<template>
	<swiper
		:spaceBetween="20"
		:slidesPerView="isMobile && links.length > 1 ? 1.25 : isMobile && links.length == 1 ? 1 : 5"
		:centeredSlides="false"
		:freeMode="{ enabled: false, sticky: false }"
		:mousewheel="true"
		:class="'slider--boxes'"
	>
		<swiper-slide v-for="l in links" :key="l.link.url">
			<TheBox v-if="!l.isNew" :title="`Linktext: ${l.link.name}`" :titleLevel="3" :class="'flex'">
				<TheButton
					v-if="allowDeleteFromServer"
					:disabled="deleteWaiting"
					type="default"
					@buttonclick="removeLinkFromServer(l)"
					:onlyIcon="true"
					class="button--closeround"
					title="Datei entfernen"
				>
					<el-icon><CloseBold /></el-icon>
				</TheButton>
				<div class="flex flex-grow flex--alignstart">
					<small>{{ $formatDate(l.link.createdDate) }}</small>
				</div>

				<el-row class="button-panel">
					<a class="el-button el-button--primary is-round" :href="getUrl(l.link)" target="_blank" :title="l.link.name"> Link öffnen </a>
					<TheButton type="default" @buttonclick="copyCode(l.link)">Link kopieren</TheButton>
				</el-row>
			</TheBox>

			<!-- NEW LINK -->
			<TheBox v-else class="box--newlink" :title="`Linktext: ${l.link.name}`" :titleLevel="3" :titleTooltip="true">
				<small>{{ $formatDate(l.link.createdDate) }}</small>

				<TheButton type="default" @buttonclick="$emit('removeFromLinks', l)" :onlyIcon="true" class="button--closeround" title="Link entfernen">
					<el-icon><CloseBold /></el-icon>
				</TheButton>

				<span class="info--upload">{{ texts.formErrors.waitingForUpload }}</span>
				<el-row class="button-panel">
					<a class="el-button el-button--primary is-round" :href="getUrl(l.link)" target="_blank" :title="l.link.name"> Link öffnen </a>
					<TheButton type="default" @buttonclick="copyCode(l.link)">Link kopieren</TheButton>
				</el-row>
			</TheBox>
		</swiper-slide>
	</swiper>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import TheButton from '../TheButton.vue';
import TheBox from '../TheBox.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { DetailLink } from '../../types/types';
import { ElMessage } from 'element-plus';
import { CloseBold } from '@element-plus/icons-vue';
import { texts } from '../../utils/texts';
import { useStore } from '../../store';
import { deleteCaseLink } from '../../requests/cases';
const ElMessageDuration = 3000;

export default defineComponent({
	name: 'LinkSlider',
	data() {
		return {
			deleteWaiting: false,
		};
	},
	components: {
		Swiper,
		SwiperSlide,
		CloseBold,
		TheButton,
		TheBox,
	},
	props: {
		links: {
			type: Array as PropType<DetailLink[]>,
			required: true,
		},
		allowDeleteFromServer: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['removeFromLinks'],
	computed: {
		texts() {
			return texts;
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			isMobile,
		};
	},
	methods: {
		getUrl(link) {
			if (!link.url) return;
			return !link.url.includes('http') ? 'http://' + link.url : link.url;
		},
		copyCode(link) {
			if (!link) return;
			const url = this.getUrl(link);
			navigator.clipboard.writeText(url);

			ElMessage({ message: 'Link wurde kopiert', type: 'success', duration: 1500 });
		},
		async removeLinkFromServer(link) {
			if (!link?.link?.id) {
				ElMessage({ message: this.texts.general.deleteFileFailed, type: 'error', duration: ElMessageDuration });
				return;
			}

			this.deleteWaiting = true;

			const deleteResult = await deleteCaseLink(link.link.id);
			if (deleteResult.success) {
				this.$emit('removeFromLinks', link);
				ElMessage({ message: this.texts.general.deleteLinkSuccess, type: 'success', duration: ElMessageDuration });
			} else {
				ElMessage({ message: this.texts.general.deleteLinkFailed, type: 'error', duration: ElMessageDuration });
			}

			this.deleteWaiting = false;
		},
	},
});
</script>
